module.exports = __webpack_public_path__ + "media/images/icon__point--default@3x-751378ca09ee493b59e5012bc7c4fdf9.png";